import { Component, computed, inject, signal } from '@angular/core';
import { groupBy } from 'lodash-es';
import * as svgIcons from '@progress/kendo-svg-icons';
import { EditDocumentAreaService } from '../../../../../../core/services/features/document-editing/edit-document-area.service';
import { InvoiceStateService } from '../../state-and-data-handling/invoice-state.service';
import { ThemeRegistry } from '../../../../../../features/invoice-theme/theme.registry';
import { SectionId } from '../../../../../../features/invoice-theme/theme.types';

@Component({
  selector: 'app-edit-document-section-handling',
  templateUrl: './edit-document-section-handling.component.html',
  styleUrl: 'edit-document-section-handling.component.scss',
  standalone: false,
})
export class EditDocumentSectionHandlingComponent {
  // Signals
  templateDef = computed(() => ThemeRegistry[this.invoiceStateService.theme()]);
  sectionsByGroup = computed(() =>
    Object.entries(groupBy(this.templateDef().sections, (s) => s.group)),
  );
  contentAreas = computed(() => this.invoiceStateService.contentAreas());
  isHidden = computed(() => {
    const areas = this.contentAreas(); // tracks changes
    // If isHidden(meta) reads any signals inside the service, those will be tracked too.
    return (id: SectionId) => {
      if (!areas?.size) {
        return false;
      }
      const meta = areas.get(id)?.meta;
      return this.editDocumentAreaService.isHidden(meta);
    };
  });

  isRemoved = computed(() => {
    const areas = this.contentAreas(); // tracks changes
    return (id: SectionId) => {
      if (!areas?.size) {
        return false;
      }
      const meta = areas.get(id)?.meta;
      return this.editDocumentAreaService.isRemoved(meta);
    };
  });

  expanded = signal(true);

  // Icons
  public readonly chevronDownIcon = svgIcons.chevronDownIcon;

  // DI
  public readonly editDocumentAreaService = inject(EditDocumentAreaService);
  private readonly invoiceStateService = inject(InvoiceStateService);

  public hover(id: SectionId | null): void {
    this.editDocumentAreaService.hover(id);
  }

  public toggleVisibility(): void {
    this.expanded.update((old) => !old);
  }
}
